import type { SVGProps } from "react";
export const Ella = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 384 130"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M74.7418 111.508L72.8918 130L22.3855 129.26L0 130V129.075C7.9552 128.151 8.69521 122.603 8.69521 98.5633V37.3542C8.69521 13.3144 7.9552 8.13656 0 7.21194V6.28734L22.3855 7.02702L71.4118 6.28734V24.5946H70.3017C69.1917 17.5676 61.9765 16.8279 50.6912 16.458L22.3855 15.5334V59.7297H50.8763C63.6416 59.7297 66.4166 59.3599 67.3416 53.4424H68.4517L67.7117 65.2774L68.4517 77.8521H67.1566C66.6016 71.7496 62.3465 70.2703 50.8763 69.9004L22.3855 68.9758V97.6387L24.2356 120.754L44.7711 120.014C67.1566 119.275 70.4867 117.425 73.4468 111.508H74.7418Z"
			fill="#A3CFF5"
		/>
		<path
			d="M95.1689 6.28734L110.524 7.02702L125.325 6.28734V7.21194C117.369 8.13656 116.629 13.3144 116.629 37.3542V94.8649L118.48 120.754L139.385 120.014C159.921 119.275 163.621 118.72 168.431 110.953H169.356L167.506 130L116.814 129.26L95.1689 130V129.075C103.124 128.151 103.864 122.603 103.864 98.5633V37.3542C103.864 13.3144 103.124 8.13656 95.1689 7.21194V6.28734Z"
			fill="#A3CFF5"
		/>
		<path
			d="M180.401 6.28734L195.756 7.02702L210.557 6.28734V7.21194C202.602 8.13656 201.862 13.3144 201.862 37.3542V94.8649L203.712 120.754L224.617 120.014C245.153 119.275 248.853 118.72 253.663 110.953H254.588L252.738 130L202.047 129.26L180.401 130V129.075C188.356 128.151 189.096 122.603 189.096 98.5633V37.3542C189.096 13.3144 188.356 8.13656 180.401 7.21194V6.28734Z"
			fill="#A3CFF5"
		/>
		<path
			d="M322.764 0L374.195 119.644C377.34 126.856 380.3 128.706 384 129.075V130L369.015 129.26L353.289 130V129.075C357.359 128.151 358.654 126.117 358.654 123.343C358.654 120.754 358.284 117.61 354.954 110.028L343.854 84.5093H299.638L288.908 110.028C285.763 117.61 285.208 120.754 285.208 123.343C285.208 126.117 286.503 128.151 290.573 129.075V130L275.772 129.26L261.897 130V129.075C265.597 128.706 268.557 126.856 271.702 119.644L322.764 0ZM306.113 73.7838H337.379L338.489 71.9346L322.393 32.7312H320.543L304.818 71.9346L306.113 73.7838Z"
			fill="#A3CFF5"
		/>
	</svg>
);
